export const SET_DATA_BY_COUNTRY = 'SET_DATA_BY_COUNTRY'
export const SET_DATA_BY_INDICATOR = 'SET_DATA_BY_INDICATOR'
export const SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY'
export const SET_COMPARISON_COUNTRY = 'SET_COMPARISON_COUNTRY'
export const SET_SELECTED_COUNTRY_DATA = 'SET_SELECTED_COUNTRY_DATA'
export const SET_COMPARISON_COUNTRY_DATA = 'SET_COMPARISON_COUNTRY_DATA'

export const setDataByCountry = (payload = {}) => ({
  type: SET_DATA_BY_COUNTRY,
  payload
})

export const setDataByIndicator = (payload = {}) => ({
  type: SET_DATA_BY_INDICATOR,
  payload
})

export const setSelectedCountry = (payload = null) => ({
  type: SET_SELECTED_COUNTRY,
  payload
})

export const setComparisonCountry = (payload = null) => ({
  type: SET_COMPARISON_COUNTRY,
  payload
})

export const setSelectedCountryData = (payload = null) => ({
  type: SET_SELECTED_COUNTRY_DATA,
  payload
})

export const setComparisonCountryData = (payload = null) => ({
  type: SET_COMPARISON_COUNTRY_DATA,
  payload
})


export const LOAD_COUNTRY_DATA_LOADING = 'LOAD_COUNTRY_DATA_LOADING'
export const LOAD_COUNTRY_DATA_ERROR = 'LOAD_COUNTRY_DATA_ERROR'
export const LOAD_COUNTRY_DATA_SUCCESS = 'LOAD_COUNTRY_DATA_SUCCESS'
export const LOAD_COUNTRY_DATA_UNLOAD = 'LOAD_COUNTRY_DATA_UNLOAD'
export const LOAD_COUNTRY_DATA = 'LOAD_COUNTRY_DATA'

export const LOAD_COMPARISON_COUNTRY_DATA_LOADING = 'LOAD_COMPARISON_COUNTRY_DATA_LOADING'
export const LOAD_COMPARISON_COUNTRY_DATA_ERROR = 'LOAD_COMPARISON_COUNTRY_DATA_ERROR'
export const LOAD_COMPARISON_COUNTRY_DATA_SUCCESS = 'LOAD_COMPARISON_COUNTRY_DATA_SUCCESS'
export const LOAD_COMPARISON_COUNTRY_DATA_UNLOAD = 'LOAD_COMPARISON_COUNTRY_DATA_UNLOAD'
export const LOAD_COMPARISON_COUNTRY_DATA = 'LOAD_COMPARISON_COUNTRY_DATA'


//export const loadCountryData = (payload) => { return { type: LOAD_COUNTRY_DATA, payload }}
//export const loadComparisonCountryData = () => ({ type: LOAD_COMPARISON_COUNTRY_DATA })


export const COUNTRY_FACILITATION = 'COUNTRY_FACILITATION'
export const loadCountryFacilitation = (payload = null) => ({
  type: COUNTRY_FACILITATION,
  payload
})
export const unloadCountryFacilitation = (payload = null) => ({
  type: 'COUNTRY_FACILITATION_UNLOAD',
  payload
})

export const THIRD_PILLAR = 'THIRD_PILLAR'
export const loadThirdPillar = (payload = null) => ({
  type: THIRD_PILLAR,
  payload
})
export const unloadThirdPillar = (payload = null) => ({
  type: 'THIRD_PILLAR_UNLOAD',
  payload
})


export const SEVEN_PILLARS = 'SEVEN_PILLARS'
export const loadSevenPillars = (payload = null) => ({
  type: SEVEN_PILLARS,
  payload
})
export const unloadSevenPillars = (payload = null) => ({
  type: 'SEVEN_PILLARS_UNLOAD',
  payload
})


export const TFA_ARTICLES = 'TFA_ARTICLES'
export const loadTfaArticles = (payload = null) => ({
  type: TFA_ARTICLES,
  payload
})
export const unloadTfaArticles = (payload = null) => ({
  type: 'TFA_ARTICLES_UNLOAD',
  payload
})

export const TFA_PROVISIONS = 'TFA_PROVISIONS'
export const loadTfaProvisions = (payload = null) => ({
  type: TFA_PROVISIONS,
  payload
})
export const unloadTfaProvisions = (payload = null) => ({
  type: 'TFA_PROVISIONS_UNLOAD',
  payload
})

export const LATEST_BY_INDICATOR = 'LATEST_BY_INDICATOR'
export const loadLatestByIndicator = (payload = null) => ({
  type: LATEST_BY_INDICATOR,
  payload
})
export const unlloadLatestByIndicator = (payload = null) => ({
  type: 'LATEST_BY_INDICATOR_UNLOAD',
  payload
})


export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

export const openModal = () => ({
  type: OPEN_MODAL
})
export const closeModal = () => ({
  type: CLOSE_MODAL
})


export const SET_COLOR_MODE = 'SET_COLOR_MODE'
export const setColorMode = (payload) => ({
  type: SET_COLOR_MODE,
  payload,
})

export const SET_COUNTRY_MODE = 'SET_COUNTRY_MODE'
export const setCountryMode = (payload) => ({
  type: SET_COUNTRY_MODE,
  payload,
})



// WEBPACK FOOTER //
// ./src/state/actions/index.js